import { customerList, customerDelete, customerStatus } from './request';
export default {
  data() {
    return {
      form: {
        name: ''
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '客户名称'
        },
        dataIndex: 'name',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '客户标识'
        },
        dataIndex: 'mark',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '负责人'
        },
        dataIndex: 'responsible',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '联系方式'
        },
        dataIndex: 'mobile',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '添加时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '操作'
        },
        key: '6',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      customerList({
        name: this.form.name,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    delItem(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该客户') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        customerDelete({
          customerId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.customerStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      customerStatus({
        customerId: val.id,
        status: val.status == 0 ? 1 : 0
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        this.getDataFun();
      });
    }
  }
};